// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1BZ-U","info":"PatientInfo_info__2ZsYj"};